module.exports = __webpack_public_path__ + "static/img/dr-7.67c647c.png";


//////////////////
// WEBPACK FOOTER
// ./src/products/dr-7.png
// module id = H9iA
// module chunks = 0